.<!-- ...... -->
<script type="text/javascript">
// ******..url..********

// var urlBase="http://192.168.1.158:8065/api";   //hardy.liu
var urlBase = "https://m.nxzyjyw.com/api";    //..

// ******....********
var imgBase="https://www.ahsjxjy.com";

export default
{
  urlBase,
  imgBase
}
</script>




// WEBPACK FOOTER //
// global.vue?d539f332